import V from 'gcl';
export const EMBMessageSender = class {
    constructor(
        middler,
        encID,
        systemID,
        appname = 'Ni',
        searchSql = 'emb-api.redis.getSystemListen',
        sendSql = "emb-api.redis.addInMessage",
        dbSql = "emb-api.redis.addDBMessage") {
        const { _, __ } = pri(this, {
            template: new V.NiTemplateManager(middler || (function() { throw new Error('必需配置template对象'); })(), appname),
            encID,
            searchSql,
            sendSql,
            dbSql
        });
        _.SystemID = systemID || (function() { throw new Error('必需配置systemID参数'); })();
    }

    async check(key) {
        const { _, __ } = pri(this);
        try {
            let res = await __.template.execute('MT', __.searchSql, { EventName: key + '.Event', encID: __.encID });
            return res.hasData();
        } catch (e) {
            console.log('EMBMessageSender.check', e.stack);
            throw e;
        }
    }
    async send(key, params, Category = 1) {
        const { _, __ } = pri(this);
        try {
            const MsgID = V.GUID(),
                now = new Date().toString('yyyy-MM-dd HH:mm:ss');
            let res = await __.template.execute('MT', __.dbSql, {
                encID: __.encID,
                value: V.toJsonString([{
                    ope: '_.emb_inmessage.add',
                    type: 0,
                    key: `emb_inmessage:${key}-${MsgID}`,
                    params: {
                        MsgID,
                        SystemID: _.SystemID,
                        MethodName: `"${key}"`,
                        Category,
                        RootMsgID: params._RootMsgID || MsgID,
                        PreMsgID: params._PreMsgID,
                        Gen: params._Gen || 0,
                        Message: `"${V.toJsonString(params)}"`,
                        MonitorID: '',
                        Priority: 1, //todo没有地方存优先级
                        DelFlag: 0,
                        CreateTime: `"${now}"`
                    }
                }])
            });
            res = await __.template.execute('MT', __.sendSql, {
                encID: __.encID,
                value: V.toJsonString({
                    MsgID,
                    SystemID: _.SystemID,
                    MethodName: key,
                    Category,
                    RootMsgID: params._RootMsgID || MsgID,
                    PreMsgID: params._PreMsgID,
                    Gen: params._Gen || 0,
                    Message: params,
                    Priority: 1, //todo没有地方存优先级 也没用
                    CreateTime: now
                })
            });
            return { success: res.hasData() && res.single().value == 1 ? true : false, MsgID };
        } catch (e) {
            console.log('RedisMessageSender.check', e.stack);
            throw e;
        }
    }
}


export default {
    EMBMessageSender
};
const pri = V.pris();